import styled from "styled-components";

interface props {
  color?: string;
  backgroundColor?: string;
}

export const Container = styled.button<props>`
  cursor: pointer;
  background: ${(props) => (props.color ? props.color : "var(--cian)")};
  width: 100%;
  padding: 0 32px;
  border-style: none;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : "var(--cian)")};

  :hover {
    opacity: 0.9;
  }

  > p {
    color: var(--white);
    font-family: var(--semiBold);
  }
`;
